import { ClientSdkCorePublic } from "../sdk/ClientSdkPublicInterface.js";
import { AuthProviderIdentifier } from "../login/AuthProviderIdentifier.js";


/**
 * Questo metodo verifica se il bottone di un AuthProvider va mostrato in interfaccia grafica. 
 * @param provider 
 * @param sdk 
 */
export function shouldShowAuthProviderButton(provider: AuthProviderIdentifier, sdk: ClientSdkCorePublic, advisedOnly: boolean = true): boolean {
    const webview = sdk.webviewDetect();
    if (provider == AuthProviderIdentifier.GOOGLE_ONE_TAP) {
        return false;
    }
    
    if (provider == AuthProviderIdentifier.FIRST_PARTY_EMAIL && !advisedOnly) {
        return true;
    }
    else if (!webview.native_app && !webview.browser.webview) {
        return true;
    }
    else if (webview.native_app && !sdk.nativeAppFeatures.isMultipleLoginSupported()) {
        if(!webview.platform.ios) {
            return provider == AuthProviderIdentifier.FACEBOOK;
        }
        else {
            return false;
        }
    }
    else if(webview.browser.webview && webview.extra && webview.extra.isFacebook) {
        if (webview.platform.android) {
            return provider == AuthProviderIdentifier.FACEBOOK;
        }
        else {
            return false;
        }
    }
    else if(!webview.native_app && webview.browser.webview) {
        return false;
    }
    else if (advisedOnly) {
        if(webview.native_app) {
            if(webview.platform.ios) {
                return provider == AuthProviderIdentifier.APPLE;
            }
            else {
                return provider == AuthProviderIdentifier.GOOGLE;
            }
        }
        else if (webview.platform.ios) {
            return false;
        }
        else if (webview.platform.macosx) {
            return provider == AuthProviderIdentifier.GOOGLE || provider == AuthProviderIdentifier.FACEBOOK || provider == AuthProviderIdentifier.APPLE;
        }
        else {
            return provider == AuthProviderIdentifier.GOOGLE || provider == AuthProviderIdentifier.FACEBOOK;
        }
        
    }
    else if (!webview.native_app && webview.platform.ios) {
        return false;
    }
    else if (webview.platform.android) {
        return provider == AuthProviderIdentifier.GOOGLE || provider == AuthProviderIdentifier.FACEBOOK;
    }
    else {
        return true;
    }
}


/**
 * Questo metodo verifica se un AuthProvider va mostrato in interfaccia grafica. 
 * @param provider 
 * @param sdk 
 */
export function getAuthProviderButtonsToShow(sdk: ClientSdkCorePublic, advisedOnly: boolean = true): Promise<AuthProviderIdentifier[]> {
    return sdk.getProviderList().then(
        list => list.filter(x => shouldShowAuthProviderButton(x, sdk, advisedOnly))
    );
}